import { render, staticRenderFns } from "./Pricing.vue?vue&type=template&id=992d3b4a&scoped=true&"
import script from "./Pricing.vue?vue&type=script&lang=js&"
export * from "./Pricing.vue?vue&type=script&lang=js&"
import style0 from "./Pricing.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Pricing.vue?vue&type=style&index=1&id=992d3b4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "992d3b4a",
  null
  
)

export default component.exports